import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type {
  PositionAlertsState,
  PositionAlertEvent,
} from '../../types/positions';

const initialState: PositionAlertsState = {
  eventsByPositionId: {},
  loading: false,
  error: null,
};

const positionAlertsSlice = createSlice({
  name: 'positionAlerts',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },

    setEventsForPosition: (
      state,
      action: PayloadAction<{ positionId: number; events: PositionAlertEvent[] }>
    ) => {
      state.eventsByPositionId[action.payload.positionId] = action.payload.events;
      state.loading = false;
    },

    ackEvent: (
      state,
      action: PayloadAction<{ positionId: number; alertId: number; at: string }>
    ) => {
      const events = state.eventsByPositionId[action.payload.positionId];
      if (!events) return;
      const ev = events.find((e) => e.id === action.payload.alertId);
      if (ev) {
        // ponytail: mutate in place (Immer draft) - avoids exactOptional object-literal mismatch
        ev.acknowledged_at = action.payload.at;
      }
    },

    clearEventsForPosition: (state, action: PayloadAction<number>) => {
      delete state.eventsByPositionId[action.payload];
    },

    clearAllAlerts: () => initialState,
  },
});

export const {
  setLoading,
  setError,
  setEventsForPosition,
  ackEvent,
  clearEventsForPosition,
  clearAllAlerts,
} = positionAlertsSlice.actions;

export default positionAlertsSlice.reducer;
